<template>
  <div class="col-span-3 grid grid-cols-subgrid items-center px-2 py-1">
    <span>{{ association.key }}</span>
    <v-autocomplete
      :items="gliders"
      item-text="key"
      item-value="key"
      :label="$t('Admin.User.Rights.GliderToSelect')"
      clearable
      hide-details
      :disabled="disabled"
      v-model="association.gliKey"
    ></v-autocomplete>
    <div class="!flex gap-2 items-center">
      <v-select
        :items="missions"
        :item-text="misLibelle"
        item-value="misId"
        :label="$t('Admin.User.Rights.MissionToSelect')"
        clearable
        v-model.number="association.misId"
        :disabled="disabled"
        hide-details
      ></v-select>
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, nextTick, PropType, watch } from 'vue'
import store from '@/store'

const props = defineProps({
  onlyOnGoing: {
    type: Boolean,
    default: false
  },
  association: {
    type: Object as PropType<{ key: string; gliKey: string | null; misId: number | null }>,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

const gliders = computed(() =>
  [
    ...new Set(
      store.myGetters.missions
        .filter(
          (m) =>
            (store.myGetters.filterEnseignePredicate(m) || m.misId == props.association.misId) &&
            (!props.onlyOnGoing || m.misActifOn == props.onlyOnGoing)
        )
        .map((m) => {
          return { id: m.gliId, key: m.gliKey?.trim()! }
        })
    )
  ].sort((a, b) => (a.key > b.key ? 1 : -1))
)
const missions = computed(() =>
  store.myGetters.missions
    .filter(
      (m) =>
        (store.myGetters.filterEnseignePredicate(m) || m.misId == props.association.misId) &&
        (!props.onlyOnGoing || m.misActifOn == props.onlyOnGoing) &&
        (!props.association.gliKey || m.gliKey?.trim() == props.association.gliKey)
    )
    .sort((a, b) => ((a?.misLibelle ?? '') < (b?.misLibelle ?? '') ? 1 : -1))
)

function misLibelle(mis: any) {
  const parts = mis.misLibelle.split('_')
  return parts.at(-1)
}

watch(
  () => props?.association?.gliKey,
  (newVal, oldVal) => {
    if (newVal != oldVal) {
      nextTick(() => {
        if (!props.association.misId || !missions.value?.some((m) => m.misId == props.association.misId)) {
          props.association.misId = missions.value?.at(0)?.misId ?? null
        }
      })
    }
  }
)
</script>
